export const SocialMedia=[
    {
        key:"instagram",
        label:"Instagram",
        icon: "./images/icons/social_icons/instagram.svg",
        link:"https://instagram.com/priyanshdatyal?igshid=ZDdkNTZiNTM="
    },
    {
        key:"mail",
        label:"Mail",
        icon: "./images/icons/social_icons/mail.svg",
        link:"mailto:priyanshdatyalclicks@gmail.com"
    }
]